import { memo } from "react";

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  MenuItemProps,
  Select as MuiSelect,
  SelectProps as MuiSelectProps,
} from "@mui/material";

import { Option } from "@/utils/types";

export type ReactNodeOption = Omit<Option, "label"> & {
  label: React.ReactNode;
};

export type SelectProps = MuiSelectProps & {
  label?: string;
  options: ReactNodeOption[];
  tooltip?: string;
  menuItemProps?: MenuItemProps;
};

const Select: React.FC<SelectProps> = ({
  options,
  label,
  sx,
  tooltip,
  menuItemProps,
  ...props
}) => {
  const hasOptions = !Array.isArray(options) || options.length === 0;
  const hasTooltip = tooltip != null && tooltip.length > 0;

  return (
    <FormControl fullWidth>
      {label != null && <InputLabel>{label}</InputLabel>}

      <MuiSelect
        label={label}
        sx={{
          bgcolor: "background.paper",
          cursor: hasOptions ? "not-allowed" : "pointer",
          ...sx,
        }}
        {...props}
      >
        {options?.map(({ disabled, label, value }, i) => (
          // @ts-expect-error - TODO: Fix when returning to Obituary Editor
          <MenuItem
            key={i}
            disabled={disabled}
            value={value}
            {...menuItemProps}
          >
            {disabled ? `${label} (ej tillgänglig)` : label}
          </MenuItem>
        ))}
      </MuiSelect>

      {hasTooltip && <FormHelperText>{tooltip}</FormHelperText>}
    </FormControl>
  );
};

export default memo(Select);
